import { render, staticRenderFns } from "./ButtonHelpKids.vue?vue&type=template&id=220f926d&scoped=true&"
import script from "./ButtonHelpKids.vue?vue&type=script&lang=js&"
export * from "./ButtonHelpKids.vue?vue&type=script&lang=js&"
import style0 from "./ButtonHelpKids.vue?vue&type=style&index=0&id=220f926d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f926d",
  null
  
)

export default component.exports